import { render, staticRenderFns } from "./loginBox2.vue?vue&type=template&id=1f5eb7b8&scoped=true"
import script from "./loginBox2.vue?vue&type=script&lang=js"
export * from "./loginBox2.vue?vue&type=script&lang=js"
import style0 from "./loginBox2.vue?vue&type=style&index=0&id=1f5eb7b8&prod&lang=scss"
import style1 from "./loginBox2.vue?vue&type=style&index=1&id=1f5eb7b8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f5eb7b8",
  null
  
)

export default component.exports